<template>
    <div>
        <!--<MobileHeader :active="active"></MobileHeader>-->
        <el-row class="header">
            <i class="el-icon-arrow-left" style="float: left; margin-top: 16px;position:absolute;left:19px;" @click="back"></i>
            <span style="font-size: 16px;">{{title}}</span>
        </el-row>
        <!--<el-page-header @back="goBack" content="详情页面">-->
        <!--</el-page-header>-->
        <el-row style="margin-top: 55px;">
            <h3 class="title">{{data.title}}</h3>
            <span class="time">发布时间：{{convertTime(data.createTime)}}</span>
        </el-row>

        <el-row class="news-content" v-html="data.content">

        </el-row>
        <MobileFooter></MobileFooter>
    </div>
</template>

<script>
    // import MobileHeader from "../../components/MobileHeader";
    import {formatFromTimeString} from "../../utils/date";
    import {newsApi} from "../../api/news-api";
    import {jobApi} from "../../api/job-api";
    import MobileFooter from "../../components/MobileFooter";

    export default {
        name: "MobileNewsDetail",
        components: {MobileFooter},
        // components: {MobileHeader},
        props: {
            id: null
        },
        data () {
            return {
                data: {},
                active: null,
                title: ''
            }
        },
        mounted () {
            this.active = this.$route.query.active;
            const titleMap = {
                job: '职位详情',
                news: '新闻详情',
                party: '党建详情',
                welfare: '公益详情'
            };
            this.title = titleMap[this.active];
            if (this.active === 'job') {
                this.loadJob();
            } else if (this.active === 'news' || this.active === 'party' || this.active === 'welfare') {
                this.loadNews();
            }
        },
        methods: {
            loadJob () {
                jobApi.info(this.id).then(res => {
                    if (res.code === 200) {
                        this.data = res.job;
                    }
                })
            },
            loadNews () {
                newsApi.info(this.id).then(res => {
                    if (res.code === 200) {
                        console.log(res);
                        this.data = res.news;
                    }
                })
            },
            back () {
                this.$router.back();
            }
        },
        computed: {
            convertTime () {
                return function (time) {
                    return formatFromTimeString(time);
                }
            }
        }

    }
</script>

<style scoped>
    .news-content {
        padding: 0 5%;
        /*min-height: 600px;*/
        text-align: left;
        margin-bottom: 60px;
        text-align: justify;
        text-justify: inter-ideograph;
    }
    .time {
        font-size: 13px;
        color: gray;
    }
    .title {
        text-align: left;
        padding: 0 5%;
    }
    .header {
        color: #616161;
        background-color: #ffffff;
        box-shadow: 0 3px 0 0 rgba(0,0,0,.05);
        height: 55px;
        line-height: 55px;
        position: fixed;
        top: 0;
        z-index: 1000;
        font-size: 30px;
        width: 100%;
    }
</style>
